<template>
  <v-card
    flat
    tile
    :id="'post-' + post.id"
    :href="post.link"
    :class="classString"
    :dark="this.dark"
  >
    <v-img
      :src="post.image"
      :aspect-ratio="16/9"
      class="grey lighten-3"
    >
      <v-card flat class="transparent d-flex fill-height">
        <v-card-text class="d-flex justify-space-around">
          <v-icon dark color="accent" size="60" class="v-icon--shadow">mdi-play</v-icon>
        </v-card-text>
      </v-card>
    </v-img>
    <v-card-subtitle
      v-if="post.series"
      v-html="'Podcasts'"  
      class="accent--text pb-0 pt-2 pb-1 text--upper"
    ></v-card-subtitle> <!-- post.series.name -->
    <v-card-subtitle
      v-else-if="post.category"
      v-html="post.category.name" 
      class="primary--text pb-0 pt-2 pb-1 text--upper"
    ></v-card-subtitle>
    <v-card-title
      v-html="post.title"
      :class="this.lead ? 'title--lead' : this.secondary ? 'subtitle-2' : ''"
      class="text--upper pt-0 pb-1 text--caslon"
    ></v-card-title>
<!--     <v-card-text
      v-html="post.excerpt
    "></v-card-text> -->
  </v-card>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'MediaCard',

    props: {
      dark: {
        type: Boolean,
        default: false
      },
      fillHeight: {
        type: Boolean,
        default: false
      },
      lead: {
        type: Boolean,
        default: false
      },
      post: {
        type: Object,
        default: () => ({})
      },
      secondary: {
        type: Boolean,
        default: false
      },
      transparent: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      classes() {
        return {
          'transparent': this.transparent,
          'fill-height': this.fillHeight,
          'v-card--lead': this.lead,
          'v-card--secondary': this.secondary
        }
      },
      classString() {
        return _.keys(_.pickBy(this.classes)).join(' ')
      }
    }
  }
</script>

<style lang="sass" scoped>
  .v-card
    .v-card__title
      word-break: normal
      line-height: 1.4rem
      font-size: 1rem
      min-height: 45px
      align-content: baseline
      word-break: normal
    .v-card__text
      -webkit-line-clamp: 2
      display: -webkit-box
      -webkit-box-orient: vertical
      overflow: hidden
      padding-bottom: 0
      margin-bottom: 16px
    &.transparent
      .v-card__title, .v-card__subtitle, .v-card__text
        padding-left: 4px
        padding-right: 4px
    // &.v-card--lead
    //   padding-bottom: 16px
    //   .v-card__title
    //     line-height: 1.6rem
    //   .v-card__text
    //     -webkit-line-clamp: 3
    //     margin-bottom: 0
    // &.v-card--secondary
    //   padding-bottom: 16px
    //   margin-bottom: 16px
    //   .v-card__text
    //     margin-bottom: 0
  .v-icon--shadow
    text-shadow: 1px 1px 20px rgba(0, 0, 0, 0.85)
</style>